import validate from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}